<template>
    <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-8">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <template>
                            <div class="text-muted text-center mb-3">
                                <small>Fazer login utilizando</small>
                            </div>
                            <auth-social-component></auth-social-component>
                        </template>
                        <template>
                            <div class="text-center text-muted mb-4">
                                <small>Ou registre-se com suas credenciais</small>
                            </div>
                            <form role="form" @submit.prevent method="get">
                                <base-input alternative
                                            v-model="inputs.first_name"
                                            id="first_name"
                                            class="mb-3"
                                            placeholder="Nome">
                                </base-input>
                                <base-input alternative
                                            v-model="inputs.last_name"
                                            id="last_name"
                                            class="mb-3"
                                            placeholder="Sobrenome">
                                </base-input>
                                <base-input alternative
                                            type="email"
                                            v-model="inputs.email"
                                            id="email"
                                            class="mb-3"
                                            placeholder="E-mail">
                                </base-input>
                                <base-input alternative
                                            v-model="inputs.username"
                                            id="username"
                                            class="mb-3"
                                            placeholder="Login">
                                </base-input>
                                <base-input alternative
                                            type="password"
                                            id="password1"
                                            v-model="inputs.password1"
                                            placeholder="Senha">
                                </base-input>
                                <base-input alternative
                                            type="password"
                                            id="password2"
                                            v-model="inputs.password2"
                                            placeholder="Repita a Senha">
                                </base-input>
                                <password v-model="inputs.password1" :strength-meter-only="true" @score="updateStrengthText" />
                                <div class="text-muted text-center mb-3">
                                    <small>força da senha:
                                        <span class="font-weight-700" :style="{color}">{{strength_password}}</span>
                                    </small>
                                </div>
                                <div class="text-center">
                                <base-checkbox v-model="inputs.checkbox">
                                    <span>Eu estou de acordo com a
                                        <a href="/politica-de-privacidade" target="_blank">Política de Privacidade</a>
                                        do site.
                                    </span>
                                </base-checkbox>
                                <div class="mt-4 mb-2">
                                    <vue-recaptcha ref="recaptcha" :sitekey="recaptchaKey" :loadRecaptchaScript="true" @verify="onVerify" @expired="onExpired" class="recaptcha-block"></vue-recaptcha>
                                </div>
                                    <base-button nativeType="submit" type="primary" @click="register($event)" class="my-4">Criar Conta</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                    <div class="row mt-3">
                        <div class="col-12 text-center">
                            <router-link to="/login" class="text-light">
                                <small>&#x27F5; Voltar e fazer Login</small>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import Password from 'vue-password-strength-meter'

import { mapGetters, mapState, mapActions } from 'vuex';

import AuthSocialComponent from "./Social/AuthSocialComponent";

import { userMixin } from "@/mixins/userMixin";

export default {
  name: "register-component",
  mixins: [userMixin],
  components: {
    Password, AuthSocialComponent },
  data() {
    return {
      modal: {
        title: 'Falha no Registro!',
        body: 'Não foi possível completar a operação',
        classe: 'modal-danger',
        icon: 'fa fa-times-circle',
        okButton: 'OK',
      },
    };
  },
  computed: {
    ...mapGetters('auth', [
        'isAuthenticated',
      ]),
    ...mapState('signup', [
        'registrationCompleted',
        'registrationError',
        'registrationLoading',
      ]),
  },
  methods: {
    ...mapActions('signup', ['clearRegistrationStatus']),
  },
  beforeRouteLeave(to, from, next) {
    
    this.clearRegistrationStatus();
    
    this.modal_header_login = false;
    this.inputs.username = null;
    this.inputs.password = null;

    next();
  }
};
</script>
